import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "pt-4"
};
const _hoisted_2 = {
  class: "flex-center p-2 mb-2"
};
const _hoisted_3 = {
  class: "flex-center p-2 mb-2"
};
const _hoisted_4 = /*#__PURE__*/_createTextVNode("-");
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import PlayerComponent from "@/modules/team/components/Player.vue";
import { Player } from "@/modules/team/entity";
import { app } from "@/di";
import GlobalResolver from "@/modules/base/services/GlobalResolver";
export default /*#__PURE__*/_defineComponent({
  __name: 'LeavingPage',
  async setup(__props) {
    let __temp, __restore;
    const expiredContracts = ref();
    const careerEnds = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      careerEnds.value = await Player.createQueryBuilder('player').innerJoinAndSelect('player.team', 'team').innerJoinAndSelect('player.country', 'country').where('team.user = true AND player.endsCareer = true AND player.contractYears = 1').getMany();
      expiredContracts.value = await Player.createQueryBuilder('player').innerJoinAndSelect('player.team', 'team').innerJoinAndSelect('player.country', 'country').where('team.user = true AND player.contractYears = 1').getMany();
    })), __temp = await __temp, __restore(), __temp);
    const onContinue = async () => {
      app.get(GlobalResolver).resolvePromise();
    };
    return (_ctx, _cache) => {
      const _component_NEmpty = _resolveComponent("NEmpty");
      const _component_Price = _resolveComponent("Price");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        "hide-tabbar": "",
        "hide-footer": ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('players_leaving_your_club')), 1)]),
        footerButtons: _withCtx(() => [_createVNode(_component_NButton, {
          type: "success",
          secondary: "",
          size: "large",
          onClick: onContinue,
          textContent: _toDisplayString(_ctx.$t('continue'))
        }, null, 8, ["textContent"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('expired_contracts')), 1), expiredContracts.value.length === 0 ? (_openBlock(), _createBlock(_component_NEmpty, {
          key: 0,
          description: _ctx.$t('no_players')
        }, null, 8, ["description"])) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(_ctx.collect(expiredContracts.value).sortByDesc('skill'), player => {
          return _openBlock(), _createBlock(PlayerComponent, {
            key: player.id,
            player: player,
            "no-link": "",
            class: "pb-2 mb-2 border-b last:border-b-0"
          }, {
            end: _withCtx(() => [_createVNode(_component_Price, {
              value: player.wage,
              "per-month": ""
            }, null, 8, ["value"])]),
            _: 2
          }, 1032, ["player"]);
        }), 128))]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('career_ends')), 1), careerEnds.value.length === 0 ? (_openBlock(), _createBlock(_component_NEmpty, {
          key: 0,
          description: _ctx.$t('no_players')
        }, null, 8, ["description"])) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(_ctx.collect(careerEnds.value).sortByDesc('skill'), player => {
          return _openBlock(), _createBlock(PlayerComponent, {
            key: player.id,
            player: player,
            "no-link": "",
            class: "pb-2 mb-2 border-b last:border-b-0"
          }, {
            end: _withCtx(() => [_hoisted_4]),
            _: 2
          }, 1032, ["player"]);
        }), 128))])]),
        _: 1
      });
    };
  }
});